import React, { FunctionComponent, MouseEventHandler } from 'react';
import { TransLink } from 'ui-components';

export const ProductWizardTransLink: FunctionComponent<{
  path: string;
  className?: string;
  onClick?: MouseEventHandler<any>;
  currentScreenCode?: string;
}> = ({ path, ...props}) => {

  return (
      <TransLink path={`/product-wizard/${path}`} {...props}/>
  );
};
